import { useQuery } from '@tanstack/react-query'
import { legalApi } from '@/lib/api/legal.api'
import { LegalDocumentType } from '@/lib/types/legal.types'

/**
 * Query key factory for legal documents
 */
export const legalKeys = {
  all: ['legal'] as const,
  documents: () => [...legalKeys.all, 'documents'] as const,
  document: (type: LegalDocumentType) => [...legalKeys.documents(), type] as const,
}

/**
 * Hook to fetch legal document by type
 * @param type - 'privacy_policy' or 'terms_conditions'
 */
export function useLegalDocument(type: LegalDocumentType) {
  return useQuery({
    queryKey: legalKeys.document(type),
    queryFn: () => legalApi.getLegalDocument(type),
    staleTime: 24 * 60 * 60 * 1000, // 24 hours - legal docs don't change often
    retry: 1,
  })
}

